import { useState } from 'react';
import { faqs } from '@/mocks/data';

export default function FAQ() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section className="py-16 md:py-24 px-6 md:px-12">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block bg-secondary-100 text-secondary-700 text-xs font-semibold px-4 py-1.5 rounded-full mb-4">
            常见问题
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-4">
            你关心的问题都在这里
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            快速了解91牛平台的常见问题，如有其他疑问欢迎随时联系我们
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
                onClick={() => toggle(faq.id)}
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-300 ${
                    openId === faq.id ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openId === faq.id && (
                <div className="px-6 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}